import React from "react";

import { Link } from "react-router-dom"; 

const FactoryAutomationCard = () => {
  return (
    
      <div className="card w-25 h-auto">
        <div className="card-body">
          <h5 className="card-title">Factory Automation</h5>
          <p className="card-text">
          Automation Manager leading projects to improve productivity 
          thru the use of Automation tools like visions systems, Robots, 
          cobots, PLC controls, Labview and IIOT.
          </p>
          <Link href="#" className="btn btn-dark" to="/factory-automation"> 
            Have a Taste!!!
          </Link>
        </div>
      </div>
  );
};

export default FactoryAutomationCard;
